import FieldConfig from "../../../proto/field-config";
import FieldDropdown from "../../../generic/dropdown/dropdown";

export default class FieldEditDuration extends FieldDropdown {


    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "EditDuration";

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',false);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Please select');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.isSearchable = false;

        this.components.PopoverMenuMore = false

        this.classes.PopoverMenu = 'min-w-200'
    }

    getOptions() {
        return [
            {label: "Previous day", value: 1},
            {label: "2 days", value: 2},
            {label: "3 days", value: 3},
            {label: "4 days", value: 4},
            {label: "5 days", value: 5},
            {label: "6 days", value: 6},
            {label: "1 week", value: 7},
        ]
    }

}
